import React from 'react';
import Title from 'components/UI/Title';
import LazyImage from 'components/UI/LazyImage';

import * as styles from './ImgSection.module.scss';

export default function ImgSection({ title, img }) {
  return (
    <section className={styles.section}>
      <Title tag="p" size="h4">
        {title}
      </Title>
      <LazyImage src={img} className={styles.scheme} />
    </section>
  );
}
